import { render, staticRenderFns } from "./Client_edit.vue?vue&type=template&id=566841aa&"
import script from "./Client_edit.vue?vue&type=script&lang=js&"
export * from "./Client_edit.vue?vue&type=script&lang=js&"
import style0 from "./Client_edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports